import { useEffect, useState } from 'react';
import { getSpecialOfferCampaign } from '../../services/specialOfferService';

export default function useSpecialOfferCampaign() {
  const [campaign, setCampaign] = useState({ settings: null, machines: [] });
  useEffect(() => {
    let mounted = true;
    getSpecialOfferCampaign()
      .then(response => { if (mounted) setCampaign(response.data?.data || { settings: null, machines: [] }); })
      .catch(() => { /* Original static campaign remains available if API is offline. */ });
    return () => { mounted = false; };
  }, []);
  return campaign;
}
